import type { EcboFeatureFlags } from './parse'
import { ECBO_MAX_COOKIE_JSON_LENGTH } from './constants'

const MAX_URI_DECODE_ROUNDS = 3

/**
 * Cookie に保存する値を生成（失敗時は null）。
 * NextResponse.cookies.set が内部で encodeURIComponent するため、ここでは生 JSON を返す。
 */
export function serializeFlagsToCookieValue(flags: EcboFeatureFlags): string | null {
  if (Object.keys(flags).length === 0) return null
  try {
    const json = JSON.stringify(flags)
    if (json.length > ECBO_MAX_COOKIE_JSON_LENGTH) return null
    return json
  } catch {
    return null
  }
}

function parseFlagsObject(json: string): EcboFeatureFlags | null {
  try {
    const parsed = JSON.parse(json) as unknown
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null
    const out: EcboFeatureFlags = {}
    for (const [k, v] of Object.entries(parsed)) {
      if (typeof k !== 'string' || typeof v !== 'string') continue
      out[k] = v
    }
    return out
  } catch {
    return null
  }
}

/**
 * Middleware 経由の Cookie 値をパースする。
 * 過去の二重 encodeURIComponent（serialize + cookies.set）も読めるよう URI デコードを繰り返す。
 */
export function deserializeFlagsFromCookieValue(encoded: string | undefined): EcboFeatureFlags {
  if (!encoded || encoded.trim() === '') return {}

  let current = encoded.trim()
  for (let round = 0; round < MAX_URI_DECODE_ROUNDS; round++) {
    const flags = parseFlagsObject(current)
    if (flags !== null) return flags

    if (!current.includes('%')) break

    try {
      const next = decodeURIComponent(current)
      if (next === current) break
      current = next
    } catch {
      break
    }
  }

  return {}
}
